<template>
    <svg
        id="Capa_1"
        style="enable-background: new 0 0 512.001 512.001"
        version="1.1"
        viewBox="0 0 512.001 512.001"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        y="0px"
    >
        <g>
            <g>
                <path
                    d="M437.019,74.982C388.668,26.63,324.381,0,256,0C187.62,0,123.333,26.63,74.981,74.982C26.629,123.334,0,187.622,0,256.002
			s26.628,132.667,74.981,181.018C123.334,485.37,187.621,512,256.001,512c68.379,0,132.668-26.629,181.019-74.981
			C485.371,388.667,512.001,324.38,512.001,256S485.371,123.333,437.019,74.982z M415.806,415.805
			c-42.686,42.686-99.439,66.193-159.805,66.193c-60.366,0-117.12-23.508-159.806-66.193
			c-42.686-42.685-66.194-99.438-66.194-159.804c0-60.367,23.508-117.12,66.193-159.806C138.881,53.51,195.633,30.002,256,30.002
			c60.367,0,117.12,23.508,159.805,66.193c42.685,42.685,66.193,99.439,66.193,159.806
			C481.999,316.367,458.491,373.121,415.806,415.805z"
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M460.722,255.995c0,0,0-0.001,0-0.002c-0.004-113.325-92.202-205.52-205.527-205.52S49.672,142.669,49.668,255.993
			c0,0.001,0,0.001,0,0.001c0,0.001,0,0.001,0,0.002c0,0.001,0,0.003,0,0.005c0,113.327,92.199,205.527,205.527,205.527
			c0.074,0,0.148-0.003,0.222-0.003c0.019,0,0.037,0.003,0.056,0.003c0.031,0,0.062-0.004,0.093-0.005
			c113.157-0.202,205.156-92.319,205.156-205.522C460.722,256,460.722,255.998,460.722,255.995
			C460.722,255.995,460.722,255.995,460.722,255.995z M240.194,81.123v68.609c-47.194,6.63-84.632,44.069-91.262,91.263H80.317
			C87.536,156.154,155.354,88.338,240.194,81.123z M240.194,180.153v60.842h-60.842
			C185.399,210.375,209.574,186.198,240.194,180.153z M240.471,430.903c-84.974-7.091-152.934-74.97-160.155-159.907h68.615
			c6.643,47.287,44.215,84.779,91.54,91.301V430.903z M240.471,331.887c-30.75-5.954-55.054-30.179-61.119-60.891h61.119V331.887z
			 M270.195,81.123c84.841,7.215,152.659,75.031,159.877,159.872h-68.614c-6.63-47.195-44.068-84.633-91.263-91.263V81.123z
			 M270.195,180.152c30.62,6.046,54.796,30.222,60.843,60.843h-60.843V180.152z M331.036,270.996
			c-6.028,30.528-30.074,54.655-60.564,60.792v-60.792H331.036z M270.473,430.854v-68.635c47.064-6.738,84.368-44.122,90.985-91.223
			h68.615C422.867,355.748,355.187,423.514,270.473,430.854z"
                />
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
</template>
<script>
export default {
    name: "Location",
};
</script>
